import * as React from "react";
const SvgListeners = (props) => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill={props.color}
      d="M24 19.333a7.91 7.91 0 0 0-3.538.831l.046-.021a.667.667 0 0 0-.273.951l-.002-.003A11.796 11.796 0 0 1 22 27.332c0 .368.298.667.667.667h8.667a.667.667 0 0 0 .667-.667 8 8 0 0 0-8-8zM28.925 13.667a5 5 0 1 1-10.001-.001 5 5 0 0 1 10.001.001zM16.333 10.333a6.333 6.333 0 1 1-12.666 0 6.333 6.333 0 0 1 12.666 0zM20 27.333c0-5.523-4.477-10-10-10s-10 4.477-10 10c0 .368.298.667.667.667h18.667a.667.667 0 0 0 .667-.667z"
    />
  </svg>
);
export default SvgListeners;
